module.exports = __webpack_public_path__ + "static/media/lightPinkCircle.65b78d9f.svg";